import { createContext, useContext } from "react";

interface HeaderContextValue {
  hasTabs: boolean;
}

const HeaderContext = createContext<HeaderContextValue>({
  hasTabs: false,
});

export const useHeaderContext = (): HeaderContextValue => {
  const ctx = useContext(HeaderContext);

  if (ctx === undefined) {
    throw new Error(`useContext must be used within HeaderContextProvider`);
  }

  return ctx;
};

export const HeaderContextProvider = HeaderContext.Provider;
